export const fullNameAutoFormat = (firstName?: string, middleName?: string, lastName?: string): string =>
  [firstName, middleName, lastName].filter(s => s).join(' ');
